import { ChangeDetectionStrategy, Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';

import { BetBuilderOptionGroupInfo } from '@cds/betting-offer/domain-specific/bet-builder';
import { EventModel, EventOptionGroup } from '@frontend/sports/betting-offer/feature/model';
import { EpcotConfig, Sitecore } from '@frontend/sports/common/client-config-data-access';
import { ThemeOptions } from '@frontend/sports/common/ui/shared';
import { SportsThemedButtonDirective } from '@frontend/sports/common/ui/sports-themed-button';
import { DsButton, DsButtonKind } from '@frontend/ui/button';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';
import { Store } from '@ngrx/store';

import { IBetslipRootState } from '../../../../betslip/base/store/state';
import { ExternalBetslipActions, PickAddPayload } from '../../../../betslip/core/external-betslip-actions';
import { getPickIds } from '../../../../betslip/core/precreated-group-option-helper';
import { PrecreatedBabTrackingService } from '../../services/precreated-bab-tracking.service';
import { getBetslipGroupInformation } from '../../utils';
import { BetBuilderOverlayHeaderComponent } from '../bet-builder-overlay-header/bet-builder-overlay-header.component';

@Component({
    selector: 'ms-betbuilder-edit-pre-created-group-button',
    templateUrl: 'bet-builder-edit-precreated-group-button.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [DsButton, SportsThemedButtonDirective, IconCustomComponent, BetBuilderOverlayHeaderComponent],
})
export class BetbuilderEditPrecreatedGroupButtonComponent implements OnInit {
    @Input() event: EventModel;
    @Input() eventOptionGroups: EventOptionGroup[];
    @Input() betbuilderOptionGroup: BetBuilderOptionGroupInfo;

    @ViewChild('header') headerTemplate: TemplateRef<any>;
    epcotEnabled = this.epcotConfig.isEnabled;
    readonly buttonThemeKind: ThemeOptions<DsButtonKind> = { 'mgm-4': 'secondary', 'mgm-dice': 'secondary', 'sports-interaction': 'secondary' };

    constructor(
        private store: Store<IBetslipRootState>,
        public sitecore: Sitecore,
        private trackingService: PrecreatedBabTrackingService,
        private epcotConfig: EpcotConfig,
    ) {}

    ngOnInit() {
        this.trackingService.trackAddorEditButtonLoad(this.event.name, this.event.sport.id, this.event.league.id);
    }

    clickHandler(mouseEvent: MouseEvent) {
        mouseEvent.stopPropagation();
        mouseEvent.preventDefault();

        const precreatedGroup = this.event.precreatedOptionGroups?.find((group) => group.groupId === this.betbuilderOptionGroup.groupId);
        if (precreatedGroup) {
            const picks: PickAddPayload[] = getPickIds(precreatedGroup, this.eventOptionGroups).map((id) => {
                return {
                    pickId: id,
                    tracking: { source: '' },
                    groupInfo: getBetslipGroupInformation(this.event),
                    isBetBuilder: true,
                };
            });

            this.addGroupPick(picks);
        }

        this.trackingService.trackAddorEditClick(
            this.event.name,
            this.event.sport.id,
            this.event.league.id,
            this.sitecore.betBuilderEntainUI.messages?.EditPickButton ?? '',
        );
    }

    addGroupPick(picks: PickAddPayload[]): void {
        this.store.dispatch(ExternalBetslipActions.addGroupPick({ picks, headerTemplate: this.headerTemplate }));
    }
}
